import React, { useEffect, useMemo, useState } from "react";

const Search = ({
  onSearch,
  value,
  placeholder = "Search…",
  debounceMs = 200,
  width = 260,
  ariaLabel = "Search",
}) => {
  // Always keep a local draft so the input is immediately editable.
  // If parent passes `value`, we sync the draft to it.
  const [draft, setDraft] = useState(typeof value === "string" ? value : "");

  useEffect(() => {
    if (typeof value === "string" && value !== draft) {
      setDraft(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const canClear = (draft || "").length > 0;
  const style = useMemo(() => ({ width }), [width]);

  // Debounce onSearch to avoid filtering on every keypress
  useEffect(() => {
    if (typeof onSearch !== "function") return;
    const t = setTimeout(() => onSearch(draft), debounceMs);
    return () => clearTimeout(t);
  }, [draft, debounceMs, onSearch]);

  const clear = () => {
    setDraft("");
    if (typeof onSearch === "function") onSearch("");
  };

  return (
    <div className="input-group" style={style}>
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        aria-label={ariaLabel}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
      />
      {canClear && (
        <button type="button" className="btn btn-outline-secondary" onClick={clear}>
          Clear
        </button>
      )}
    </div>
  );
};

export default Search;
